import { getIdCardExpirationDateByBirthDate } from '@components/shared/IdentificationDocumentSelection/utils/validations/expiryDate';
import { DocumentType } from '@documents-upload/types';
import { addYears, getDate, getMonth, getYear, isAfter, isBefore, isEqual, parse, subDays } from 'date-fns';

const ID_CARD_EXPIRY_SUPERIOR_LIMIT = 11;
const MANDATORY_FIELD_MESSAGE = 'Questo campo è obbligatorio.';
const INVALID_DATE_MESSAGE = 'La data non è valida. Verificala sul tuo documento.';
const DATE_NOT_COMPLETE = 'La data non è completa';
const DATE_FORMAT = 'yyyy-MM-dd';

export const todayValueDate = () => {
  let today = new Date();
  let day = today.toLocaleString('en-US', { day: '2-digit' });
  let month = today.toLocaleString('en-US', { month: '2-digit' });
  let year = today.getFullYear();
  return `${year}-${month}-${day}`;
};

export const elevenYearsAgo = () => {
  let today = new Date();
  let day, month, year;
  day = today.toLocaleString('en-US', { day: '2-digit' });
  month = today.toLocaleString('en-US', { month: '2-digit' });
  year = today.getFullYear() - 11;
  return `${year}-${month}-${day}`;
};

export const elevenYearsLater = () => {
  let today = new Date();
  let day, month, year;
  day = today.toLocaleString('en-US', { day: '2-digit' });
  month = today.toLocaleString('en-US', { month: '2-digit' });
  year = today.getFullYear() + 11;
  return `${year}-${month}-${day}`;
};

export const handleValidateDrivingLicenceIssueDate = (
  drivingLicenceIssueDate: string,
  birthdate: string,
  setIssueDateError: (value: boolean) => void,
  setIssueDateErrorMessage: (value: string) => void,
  isDrivingLicenceInput: boolean
) => {
  const parsedIssueDate = parse(drivingLicenceIssueDate, DATE_FORMAT, new Date());
  const issueDateYear = getYear(parsedIssueDate);
  const parsedBirthDate = parse(birthdate, DATE_FORMAT, new Date());
  const birthDateDay = getDate(parsedBirthDate);
  let eligibleDriverYearCalc = JSON.parse(JSON.stringify(birthDateDay));
  eligibleDriverYearCalc += 13;

  if (isDrivingLicenceInput) {
    if (!drivingLicenceIssueDate || !birthdate) {
      setIssueDateErrorMessage(DATE_NOT_COMPLETE);
      setIssueDateError(true);
      return false;
    }
    if (issueDateYear <= eligibleDriverYearCalc) {
      setIssueDateErrorMessage(INVALID_DATE_MESSAGE);
      setIssueDateError(true);
      return false;
    }
  }
  return true;
};

export const handleValidateIssueDate = (
  value: string,
  setIssueDateError: (value: boolean) => void,
  setIssueDateErrorMessage: (value: string) => void,
  expirationDate: string,
  birthDate: string
) => {
  const dateOnChange = new Date(value);
  const dateOfTheDay = new Date(todayValueDate());
  const dateOfExpiration = expirationDate && new Date(expirationDate);

  const month = dateOnChange.getMonth() + 1;
  const day = dateOnChange.getDate();
  const formattedBirthDate =
    (birthDate && new Date(birthDate.replace(/(\d{2})[-/](\d{2})[-/](\d+)/, '$2/$1/$3'))) || undefined;

  if (value === '') {
    setIssueDateError(true);
    setIssueDateErrorMessage(MANDATORY_FIELD_MESSAGE);
  } else if (
    (dateOfExpiration && dateOfExpiration.getFullYear() - 11 > dateOnChange.getFullYear()) ||
    dateOnChange > dateOfTheDay ||
    (day === 1 && month === 1) ||
    (formattedBirthDate && dateOnChange < formattedBirthDate)
  ) {
    setIssueDateErrorMessage('Controlla le date inserite');
    setIssueDateError(true);
  } else {
    setIssueDateError(false);
    setIssueDateErrorMessage('');
  }
  return true;
};

export const formatBirthDate = (birthDate: string) => {
  return new Date(birthDate.replace(/(\d{2})[-/](\d{2})[-/](\d+)/, '$2/$1/$3'));
};
export const handleValidateExpiryDate = (
  value: string,
  issueDate: string,
  birthDate: string,
  isItPassport: boolean,
  setExpiryDateError: (value: boolean) => void,
  setExpiryDateErrorMessage: (value: string) => void,
  documentType: DocumentType
) => {
  const parsedExpiryDate = parse(value, DATE_FORMAT, new Date());
  const parsedIssueDate = parse(issueDate, DATE_FORMAT, new Date());
  const expectedExpiringDate = getIdCardExpirationDateByBirthDate(birthDate, issueDate, documentType);
  if (!value) {
    setExpiryDateError(true);
    setExpiryDateErrorMessage(MANDATORY_FIELD_MESSAGE);
  }
  if (isItPassport) {
    return handlePassportValidationExpirationDate(value, issueDate, setExpiryDateError, setExpiryDateErrorMessage);
  }
  if (isBefore(new Date(value), expectedExpiringDate)) {
    setExpiryDateError(true);
    setExpiryDateErrorMessage(INVALID_DATE_MESSAGE);
  }
  if (isAfter(new Date(value).setHours(0, 0, 0, 0), expectedExpiringDate)) {
    setExpiryDateError(true);
    setExpiryDateErrorMessage(INVALID_DATE_MESSAGE);
  }
  if (getYear(parsedExpiryDate) > getYear(parsedIssueDate) + ID_CARD_EXPIRY_SUPERIOR_LIMIT) {
    setExpiryDateError(true);
    setExpiryDateErrorMessage(INVALID_DATE_MESSAGE);
  }
  if (
    getMonth(parsedExpiryDate) + 1 !== getMonth(parse(birthDate, DATE_FORMAT, new Date())) + 1 ||
    getDate(parsedExpiryDate) !== getDate(parse(birthDate, DATE_FORMAT, new Date()))
  ) {
    setExpiryDateError(true);
    setExpiryDateErrorMessage(INVALID_DATE_MESSAGE);
  }

  return true;
};
export const handlePassportValidationExpirationDate = (
  expiryDate: string,
  issueDate: string,
  setExpiryDateError: (value: boolean) => void,
  setExpiryDateErrorMessage: (value: string) => void
) => {
  const parsedExpiryDate = parse(expiryDate, DATE_FORMAT, new Date());
  const parsedIssueDate = parse(issueDate, DATE_FORMAT, new Date());
  if (!expiryDate) {
    setExpiryDateError(true);
    setExpiryDateErrorMessage(MANDATORY_FIELD_MESSAGE);
  }

  const dateWithExpectedYear = addYears(parsedIssueDate, 10);
  const expectedExpiryDate = subDays(dateWithExpectedYear, 1);
  if (!isEqual(expectedExpiryDate, parsedExpiryDate)) {
    setExpiryDateError(true);
    setExpiryDateErrorMessage(INVALID_DATE_MESSAGE);
  }
};

export const handleControlPepDate = (
  value: string,
  setDataPepError: (value: boolean) => void,
  setDataPepErrorMex: (value: string) => void
) => {
  if (value === '') {
    setDataPepError(true);
    setDataPepErrorMex(DATE_NOT_COMPLETE);
  } else if (value > todayValueDate()) {
    setDataPepError(true);
    setDataPepErrorMex('La data non può essere successiva a quella odierna');
  } else {
    setDataPepError(false);
    setDataPepErrorMex('');
  }
};

export const handleClickPepData = (
  setDataPepError: (value: boolean) => void,
  setDataPepErrorMex: (value: string) => void
) => {
  setDataPepError(false);
  setDataPepErrorMex('');
};
